/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

const Suggestions = (props) => {
  const categoryOptionText = ({ productType = '', name = '' }) => {
    return productType === 'categories' ? `In -> ${name}` : name;
  };

  const handleCategoryOptionClick = (result) => {
    if (!result) return;

    const { productType, id } = result;

    if (productType === 'categories') {
      props.handleCategoryClick(id);
    } else {
      props.handleClick(productType, id);
    }
  };

  const handleClickEvent = (result) => (event) => {
    event.preventDefault();
    handleCategoryOptionClick(result);
  };

  const options = props.results.map((result) => (
    <li key={result.id}>
      <a
        onMouseDown={handleClickEvent(result)}
        onTouchStart={handleClickEvent(result)}
      >
        {categoryOptionText(result)}
      </a>
    </li>
  ));

  return (
    <>
      <ul>
        {options}
        {props.tags?.length > 0 && (
          <li className='tags-container'>
            <section className='tags'>
              <div className='title align-left'>Suggested Tags</div>
              <div className='badge-area'>
                {props.tags.map((tag) => (
                  <a key={tag} className='badge' href={`/shop/?query=${tag}`}>
                    {tag}
                  </a>
                ))}
              </div>
            </section>
          </li>
        )}
      </ul>
    </>
  );
};

export default Suggestions;
